import type { ValiError } from 'valibot'
import type { FormFieldErrors, EnableCheckFlg } from '@/types/form'
import { getKeys, getEntries } from '@/utils/object'

export const createEnableCheckFlg = <T extends object>(fields: T): EnableCheckFlg<T> =>
  getKeys(fields).reduce((acc, ac) => ((acc[ac] = false), acc), {} as EnableCheckFlg<T>)

export const createEmptyFormFieldErrors = <T extends object>(fields: T): FormFieldErrors<T> =>
  getKeys(fields).reduce((acc, ac) => ((acc[ac] = []), acc), {} as FormFieldErrors<T>)

// EnableCheckFlgがtrueのform field errorsのみを抽出するヘルパー
export const emptyTargetFields = <T>(
  formFieldErrors: FormFieldErrors<T>,
  enableCheckFlg: EnableCheckFlg<T>
): FormFieldErrors<T> =>
  getEntries(formFieldErrors).reduce((acc, ac) => {
    const [key, val] = ac
    acc[key] = enableCheckFlg[key] ? val : []
    return acc
  }, {} as FormFieldErrors<T>)

export const normalizeValiError = <T extends object>(error: ValiError): Partial<FormFieldErrors<T>> => {
  const { issues } = error

  const fieldErrors = {} as Partial<FormFieldErrors<T>>

  for (const issue of issues) {
    const { path = [], message } = issue
    for (const pathItem of path) {
      switch (pathItem.type) {
        case 'object':
          fieldErrors[pathItem.key as keyof T] = [message]
          break;
        default:
          console.log('unknown ValiError path item schema: ' + pathItem.type)
          break;
      }
    }
  }

  return fieldErrors
}
